import { createContext, useContext } from 'react';

const PreferencesContext = createContext(null);

const usePreferences = () => useContext(PreferencesContext);

export { PreferencesContext, usePreferences };